import { offersOptions } from '@/apis/pam-store-api'
import { SpecialOfferItemsSetDeeplinkError } from '@/features/store/buy-gold-coins/special-offer-items-set/special-offer-item-set-deeplink-error'
import { createFileRoute, notFound, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/store/buy-gold-coins/$id')({
  beforeLoad: async ({ search, location, params, context }) => {
    const allOffers = await context.queryClient.ensureQueryData(offersOptions())

    const doesSpecialOfferItemSetExist = allOffers.specialOfferSets.some(
      (offer) => offer.id === params.id,
    )

    if (!doesSpecialOfferItemSetExist) {
      throw notFound()
    }

    throw redirect({
      to: '/',
      search: {
        ...search,
        store: 'buy-gold-coins',
        'special-offer-item-set-id': params.id,
      },
      state: location.state,
    })
  },
  errorComponent: SpecialOfferItemsSetDeeplinkError,
})
